document.addEventListener("turbolinks:load", function() {
  $('.rating').rating('reset');
  $(".rating-stars > .rating-container").remove()
})
